import styled from 'styled-components'

export const WarningContainer = styled.div`
  display: flex;
  justify-content: center;
  margin: 32px auto 0;
`
